// src/components/filter.
import React, { useEffect, useMemo, useState } from "react"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PuffLoading from "components/Loading/PuffLoading"
import { Col, Row } from "reactstrap"
import Pagination from "../../components/pagination"
import { Link } from "react-router-dom"
import { useLazyQuery } from "@apollo/client"
import PaginatedTable from "components/Table/PaginatedTable"
import OvalLoading from "components/Loading/OvalLoading"
import { GET_ALL_PRODUCTS } from "graphql/queries/product"
import { LINKS } from "utils/links"

function Products() {

  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  const [totalCount, setTotalCount] = useState(0)
  const [searchTerm, setSearchTerm] = useState("")
  const [productData, setProductsData] = useState([])
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("")

  // Server side searching
  const [search, { loading: searchLoading, __, data, error }] =
    useLazyQuery(GET_ALL_PRODUCTS, {
      onCompleted: data => {
        const totalCount = data?.GetAllProducts?.totalCount
        if (page > Math.ceil(totalCount / perPage)) {
          setPage(1)
        }
        setProductsData(data?.GetAllProducts?.products || [])
        setTotalCount(totalCount)
      },
    })

  // First time load all data with pagination
  useEffect(() => {
    if (debouncedSearchTerm.trim() === "") {
      search({
        variables: {
          page: page,
          perPage: perPage,
          search: searchTerm?.trim(),
        },
      })
    }
  }, [debouncedSearchTerm, page, perPage])

  const getProductsHandle = (e) => {
    e.preventDefault()
    search({
      variables: {
        page: page,
        perPage: perPage,
        search: searchTerm?.trim(),
      },
    })
  }

  if (error) {
    console.log(error)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Product ID",
        accessor: "product_id",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "SKU",
        accessor: "sku",
      },
      {
        Header: "Stock Quantity",
        accessor: "stock_quantity",
      },
      {
        Header: "Price",
        accessor: "price",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "_id",
        Cell: ({ value }) => {
          return (
            <div className="d-flex gap-3">
              <Link className="text-success" to={`${LINKS.stock_management}/edit/${value}`}>
                <i className="mdi mdi-pencil font-size-18"></i>
              </Link>
            </div>
          )
        },
      },
    ],
    [productData]
  )

  document.title = "Products | Stock Management"

  return (
    <div className="page-content">
      {searchLoading && <PuffLoading />}
      <div className="container-fluid">
        <Breadcrumbs title="Stock Management" breadcrumbItem="Products" />


        <div className={totalCount <= perPage ? "mt-5" : "mt-5"}>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <form
                onSubmit={getProductsHandle}
                className="search-box d-flex align-items-center gap-2 mb-2"
              >
                <div className="position-relative">
                  <label htmlFor="search-bar-0" className="search-label mb-0">
                    <span id="search-bar-0-label" className="sr-only">
                      Enter SKU
                    </span>
                    <input
                      onChange={e => {
                        setSearchTerm(e.target.value)
                      }}
                      id="search-bar-0"
                      type="text"
                      className="form-control"
                      placeholder={`Enter SKU`}
                      value={searchTerm}
                    />
                  </label>
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
                <button type="submit" className="btn btn-primary waves-effect waves-light btn btn-primary">Search</button>
              </form>
            </Col>
            <Col md={8}>
              <Pagination
                totalRows={totalCount}
                pageChangeHandler={setPage}
                rowsPerPage={perPage}
                setRowsPerPage={setPerPage}
                currentPage={page}
              />
            </Col>
          </Row>


          <div className="position-relative">
            {searchLoading && <OvalLoading />}
            <PaginatedTable
              columns={columns}
              data={productData || []}
              isLoading={searchLoading}
            />
          </div>
          <Pagination
            totalRows={totalCount}
            pageChangeHandler={setPage}
            rowsPerPage={perPage}
            setRowsPerPage={setPerPage}
            currentPage={page}
          />
        </div>
      </div>
    </div>
  )
}

export default Products
